import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const StreamStatsInfo = ({ stats }) => {
  if (!stats) return null;

  const {
    bitrateKbps,
    packetsLost,
    jitter,
    rtt,
    resolution,
    fps,
    codec,
    framesDecoded,
    framesDropped,
  } = stats;

  const tooltipContent = (
    <div style={{ fontSize: "0.85rem", lineHeight: "1.4" }}>
      <div>
        <strong>Bitrate:</strong> {bitrateKbps ?? "N/A"} kbps
      </div>
      <div>
        <strong>Packets Lost:</strong> {packetsLost ?? "N/A"}
      </div>
      <div>
        <strong>Jitter:</strong> {jitter ?? "N/A"} ms
      </div>
      <div>
        <strong>RTT:</strong> {rtt ?? "N/A"} s
      </div>
      <div>
        <strong>Resolution:</strong> {resolution ?? "N/A"}
      </div>
      <div>
        <strong>FPS:</strong> {fps ?? "N/A"}
      </div>
      <div>
        <strong>Codec:</strong> {codec ?? "N/A"}
      </div>
      <div>
        <strong>Frames Decoded:</strong> {framesDecoded ?? "N/A"}
      </div>
      <div>
        <strong>Frames Dropped:</strong> {framesDropped ?? "N/A"}
      </div>
    </div>
  );

  return (
    <Tooltip title={tooltipContent} placement="top" arrow>
      <IconButton size="small">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default StreamStatsInfo;
